<template>
    <div class='list-wrapper'>
        <div class='item' 
            v-for='( item, index) in tabList' 
            :key='item.id'
            @click='handleItemClick( item, index)'>
            <list-tab 
                :title='item.title'
                :leftSlot='""'
                :rightSlot='computedStr(item)'
                :checked='selectId == item.id || selectId == item.seq'
                :had-read='item.hasRead'
            ></list-tab>
        </div>
    </div>
</template>

<script>
import listTab from '@/base/list_tab'
import * as client from '@/common/js/client'
import * as utils from '@/common/js/utils'
export default {
    name: 'news',
    data () {
        return {
            scrollEvent: 0,
            tabList: [], // 左侧列表数据
            selectId: '',
            model: {}    
        }
    },
    props:['value','detail'],// 此处用props传值还是使用$parent 获取  还有待商榷
    inject:['pageDetail'],
    filters:{
        formatListDate(item,vm){
            return  (item.source || "" ) + " " + vm.$utils.thscSnsBaselibUtils.getPublishTime((item.ctime || item.time) * 1000, {
				'60s': '刚刚',
				'60m': '{nm}分钟前',
				'yesterday': '昨天{hh}:{mm}',
				'24h': '{nh}小时前',
				'1y': '{YYYY}-{MM}-{DD} {hh}:{mm}',
				'xy': '{YYYY}-{MM}-{DD}'
			})
        }
    },
    components:{
        listTab
    },
    computed: {
    },
    beforeCreate: function () {
    },
    created: function () {
        this.$project.getLocalStorage('historyArticle','v1.0',(res ) => {
            this.tabList = res;
            console.log('左侧列表数据tablist-----', res)
            this.handleItemClick(this.tabList[0])
        })
    },
    mounted: function () {
        // console.log( 33)
    },
    methods: {
        computedStr(item){
            return  (item.source || "" ) + " " + this.$utils.thscSnsBaselibUtils.getPublishTime((item.ctime || item.time) * 1000, {
				'60s': '刚刚',
				'60m': '{nm}分钟前',
				'yesterday': '昨天{hh}:{mm}',
				'24h': '{nh}小时前',
				'1y': '{YYYY}-{MM}-{DD} {hh}:{mm}',
				'xy': '{YYYY}-{MM}-{DD}'
			})
        },
        handleItemClick( item){
            this.selectId = item.id || item.seq;
            let obj = JSON.parse(JSON.stringify(item))
            this.$emit( 'input', obj);
            this.$emit( 'change', obj);
            item.hasRead = true;
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../common/style/index.less';
.list-wrapper{
    width: 243px;
    height: 100%;
    .item{
        margin-bottom: 10px;
    }
}
</style>
